<div class="flex flex-col h-full sm:h-auto justify-between sm:justify-start gap-6">
    <div class="mt-auto sm:mt-0">
        <p class="text-base">Two portals become one on November 9th</p>
        <!-- <p class="text-base">Part 4 in a 5-part webinar series</p> -->
        <p class="text-[32px] font-bold">Meet Your New AVANA CUSO Portal</p>
        <!-- <p class="text-[32px] font-bold">Legal Action and Strategy Plan</p> -->
        <!-- <p class="text-base max-w-[420px]">Legal Action and Strategy Plan</p> -->
    </div>
    <div class="flex flex-col sm:flex-row gap-6">
        <div class="bg-Gray-100 rounded px-4 py-2.5 flex flex-col justify-center gap-3">
            <div class="flex items-center gap-2">
                <img src="assets/icons/calendar.svg" alt="calendar">
                <p class="text-base">November 5th, 2026</p>
                <!-- <p class="text-base">December 4th, 2025</p> -->
            </div>
            <div class="flex items-center gap-2">
                <img src="assets/icons/clock.svg" alt="clock">
                <p class="text-base">10 AM PST</p>
                <!-- <p class="text-base">10 AM PT</p> -->
            </div>
        </div>
        <div class="bg-Gray-100 rounded px-4 py-3 flex gap-2">
            <img src="assets/images/Anish.jpg" alt="Anish Dhanjee" class="w-[70px] h-[70px] rounded object-cover">
            <!-- <img src="assets/icons/Steven-picture.svg" alt="picture" class="w-[70px] h-[70px] rounded"> -->
            <!-- <img src="assets/images/matthew_hunt.png" alt="picture" class="w-[70px] h-[70px] rounded"> -->
            <div>
                <p class="text-base font-extrabold">Anish Dhanjee</p>
                <!-- <p class="text-base font-extrabold">Steven Ellsworth</p> -->
                <!-- <p class="text-base font-extrabold">Matthew Hunt</p> -->
                <p class="max-w-[200px] text-Gray-800 text-sm">Senior Digital Product Manager at AVANA Companies</p>
                <!-- <p class="max-w-[200px] text-Gray-800 text-sm">SVP of Portfolio Management at AVANA Companies</p> -->
                <!-- <p class="max-w-[200px] text-Gray-800 text-sm">Chief Credit Officer at AVANA Companies</p> -->
            </div>
        </div>
    </div>
    <div class="flex gap-2.5 mt-auto sm:mt-0">
        <!-- <button class="h-12 border border-Gray-400 rounded px-6 py-3 hover:bg-Gray-100"
            (click)="redirectTo('learn-more')">Learn more</button> -->
        <button class="h-12 bg-main text-white rounded px-6 py-3 hover:bg-main_hover"
            (click)="redirectTo('register')">Register now</button>
    </div>
</div>
